"use client";

import React from "react";
import { Clock, Map, Gem, Mountain } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const experiences = [{
  title: "Historic Candelaria Tour",
  description: "Wander through the cobblestone streets of Bogotá's oldest neighborhood. Discover colonial architecture, vibrant street art, and the rich history that shaped the city.",
  time: "4 Hours",
  icon: Map
}, {
  title: "Gold Museum Private Viewing",
  description: "Experience the world's largest collection of pre-Hispanic gold artifacts with an expert curator. Uncover the myths and legends of El Dorado in an intimate setting.",
  time: "2.5 Hours",
  icon: Gem
}, {
  title: "Monserrate Sunset Ascent",
  description: "Ascend the iconic mountain by cable car as the sun sets over the Andean capital. Enjoy panoramic views and a gourmet dining experience at the summit.",
  time: "3 Hours",
  icon: Mountain
}];
const images = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/candelaria_historic_street.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/candelaria_historic_street.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/candelaria_historic_street.png-wvc-sizes",
  alt: "Historic Candelaria Street View"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/gold_museum_exhibit.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/gold_museum_exhibit.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/gold_museum_exhibit.png-wvc-sizes",
  alt: "Gold Museum Artifacts"
}];
export default function ExclusiveExperiences() {
  return <section id="exclusive-experiences" className="bg-background py-[160px] overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          
          {}
          <div className="relative hidden lg:block h-full">
            <div className="sticky top-32 flex flex-col gap-12 pb-32">
              {images.map((img, i) => <div key={i} data-index={i} className="relative rounded-xl overflow-hidden shadow-2xl">
                  <AspectRatio ratio={3 / 4}>
                    <img src={img.src} data-wvc-srcset={img.srcset} data-wvc-sizes={img.sizes} alt={img.alt} className="object-cover w-full h-full transition-transform duration-700 hover:scale-105" loading="lazy" />
                  </AspectRatio>
                </div>)}
            </div>
          </div>

          {}
          <div className="flex lg:hidden flex-col gap-8 mb-8">
             {images.map((img, i) => <div key={`mobile-img-${i}`} data-index={i} className="relative rounded-xl overflow-hidden shadow-lg">
                  <AspectRatio ratio={4 / 3}>
                    <img src={img.src} data-wvc-srcset={img.srcset} data-wvc-sizes={img.sizes} alt={img.alt} className="object-cover w-full h-full" loading="lazy" />
                  </AspectRatio>
                </div>)}
          </div>

          {}
          <div className="flex flex-col justify-center">
            <div className="mb-16">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-semibold text-foreground mb-6 tracking-tight">
                Exclusive Experiences
              </h2>
              <p className="text-lg md:text-xl text-muted-foreground font-sans max-w-md">
                Curated journeys through the heart of Colombia's heritage, designed for the discerning traveler.
              </p>
            </div>

            <div className="flex flex-col gap-12">
              {experiences.map((exp, i) => {
              const Icon = exp.icon;
              return <div key={i} data-index={i} className="group relative">
                    <Card className="bg-foreground/95 backdrop-blur-[20px] border-none text-background transition-all duration-500 hover:-translate-y-2 hover:brightness-110 shadow-xl overflow-hidden">
                      <CardHeader className="pb-4">
                        <div className="flex items-center gap-4 mb-2">
                          <div className="p-2 bg-secondary/20 rounded-full text-secondary">
                            <Icon className="w-6 h-6" />
                          </div>
                          <CardTitle className="font-default text-2xl md:text-3xl text-background font-semibold">
                            {exp.title}
                          </CardTitle>
                        </div>
                      </CardHeader>
                      <CardContent>
                        <p className="font-sans text-background/80 leading-relaxed mb-8 text-base md:text-lg">
                          {exp.description}
                        </p>
                        <div className="flex items-center gap-2 text-secondary font-sans text-sm uppercase tracking-widest font-medium">
                          <Clock className="w-4 h-4" />
                          <span>{exp.time}</span>
                        </div>
                      </CardContent>
                    </Card>
                    
                    {}
                    {i < experiences.length - 1 && <div className="absolute -bottom-6 left-0 h-px w-full bg-gradient-to-r from-transparent via-secondary to-transparent opacity-40" />}
                  </div>;
            })}
            </div>
          </div>

        </div>
      </div>
    </section>;
}